'use client';
import React, { useEffect, useRef, useState } from 'react';

const stats = [
  { value: '$2B+', label: 'Loans Facilitated', suffix: '' },
  { value: '500+', label: 'Satisfied Clients', suffix: '' },
  { value: '15+', label: 'Years Experience', suffix: '' },
  { value: '98%', label: 'Approval Rate', suffix: '' },
];

export default function Stats() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="w-full bg-brand-navy py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div ref={ref} className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats?.map((stat, index) => (
            <div
              key={stat?.label}
              className={`text-center transition-all duration-700 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="font-serif text-4xl md:text-5xl font-bold text-white mb-2">
                {stat?.value}
              </div>
              <div className="font-sans text-brand-green text-sm font-medium tracking-wide uppercase">
                {stat?.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
